import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ZapIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    const target = document.getElementById('pricing');
    if (!target) return;
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const duration = 1500; // 1.5 seconds for a 'slow' feel
    let start: number | null = null;
    function step(timestamp: number) {
      if (!start) start = timestamp;
      const progress = timestamp - start;
      const percentage = Math.min(progress / duration, 1);
      // Easing function (easeInOutCubic)
      const ease = percentage < 0.5 ? 4 * percentage * percentage * percentage : 1 - Math.pow(-2 * percentage + 2, 3) / 2;
      window.scrollTo(0, startPosition + distance * ease);
      if (progress < duration) {
        window.requestAnimationFrame(step);
      }
    }
    window.requestAnimationFrame(step);
  };
  return <section className="relative overflow-hidden bg-transparent pt-[0px] pb-[0px]" data-id="element-160" data-mp="2bf856eq18da4">
      {/* Background Glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full pointer-events-none" data-id="element-161" data-mp="2p6mpqpzl8mja">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-[#00f0ff]/20 blur-[120px] rounded-full" data-id="element-162" data-mp="2kdadzgg0ca7y" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-[#ec4899]/20 blur-[120px] rounded-full" data-id="element-163" data-mp="2z5lxm6cj4e58" />
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-0" data-id="element-164" data-mp="384pldnmn5hq2">
        <div className="relative" data-id="element-165" data-mp="381tnu0epgv25">
          <img src="https://cdn.magicpatterns.com/uploads/d1jBqiVyYbs7htMf3zRkDC/ChatGPT_Image_29_may_2026,_12_30_43.webp" alt="Hero Neon Flex" className="w-full h-auto block shadow-[0_0_50px_rgba(0,240,255,0.15)]" loading="eager" fetchPriority="high" data-id="element-166" data-mp="334uu3iyyeq4h" />

          <div className="absolute bottom-[10%] left-1/2 -translate-x-1/2 w-full flex justify-center px-4" data-id="element-167" data-mp="38umlwdfwqipn">
            <motion.button whileHover={{
            scale: 1.04,
            boxShadow: '0 0 50px rgba(236, 72, 153, 0.9)'
          }} whileTap={{
            scale: 0.97
          }} transition={{
            duration: 0.2
          }} onClick={scrollToPricing} className="bg-gradient-to-r from-[#ec4899] to-[#8b5cf6] text-white font-black text-lg md:text-2xl px-10 py-4 md:px-16 md:py-6 rounded-xl uppercase tracking-widest transition-all border-2 border-white/20 shadow-[0_10px_40px_rgba(236,72,153,0.4)] whitespace-nowrap" data-id="element-168" data-mp="3dsxvqo67ct7v">
              ACCEDE AHORA
            </motion.button>
          </div>
        </div>
      </div>
    </section>;
}